var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute text-primary top-1/2 transform -translate-y-1/2 -left-0.2"},[_c('icon',{class:{ 'transform rotate-180': _vm.dir === _vm.SortDir.DESC },attrs:{"icon":_vm.SortArrowSvg,"size":_vm.IconSize.XS}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }